import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { Leaf, LogIn, Eye, EyeOff, Link as LinkIcon } from 'lucide-react'
import api from '../../services/api'

export default function LoginPage() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  
  const { register, handleSubmit, formState: { errors } } = useForm()

  const onSubmit = async (data) => {
    setLoading(true)
    try {
      const formData = new URLSearchParams()
      formData.append('username', data.email)
      formData.append('password', data.password)
      
      const response = await api.post('/api/auth/login', formData, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      
      localStorage.setItem('token', response.data.access_token)
      toast.success('Connexion réussie !')
      navigate('/admin')
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Email ou mot de passe incorrect')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div 
        className="min-h-screen flex items-center justify-center p-4 bg-no-repeat bg-center bg-contain"

      style={{
        // L'astuce : un dégradé semi-transparent superposé à l'image !
        backgroundImage: `linear-gradient(to bottom right, rgba(246, 247, 244, 0.85), rgba(254, 249, 195, 0.85)), url('/images/phenix.jpg')`
      }}
    >
      <div className="card max-w-md w-full relative z-10 shadow-2xl backdrop-blur-sm bg-white/90">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-br from-sun-300 to-peach-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Leaf className="w-8 h-8 text-sage-600" />
          </div>
          <h1 className="text-2xl font-serif text-sage-700">Administration</h1>
          <p className="text-sage-500 mt-1">Espace Professionnel Sécurisé</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-sage-700 mb-1">
              Email
            </label>
            <input
              type="email"
              autoComplete="email"
              {...register('email', { required: 'Email requis' })}
              className="w-full"
              placeholder=""
            />
            {errors.email && (
              <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-sage-700 mb-1">
              Mot de passe
            </label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                autoComplete="current-password"
                {...register('password', { required: 'Mot de passe requis' })}
                className="w-full pr-10"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-sage-400 hover:text-sage-600"
              >
                {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
              </button>
            </div>
            {errors.password && (
              <p className="text-red-500 text-sm mt-1">{errors.password.message}</p>
            )}
            <div className="text-right mt-1">
              <Link to="/admin/forgot-password" className="text-xs text-sage-600 hover:text-sage-800 hover:underline">Mot de passe oublié ?</Link>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary w-full flex items-center justify-center gap-2"
          >
            {loading ? (
              <div className="spinner w-5 h-5" />
            ) : (
              <>
                <LogIn className="w-5 h-5" />
                Se connecter
              </>
            )}
          </button>
        </form>
        <p className="mt-6 text-center text-sm text-sage-500">
          Vous n’avez pas encore de compte ?{" "}
          <Link to="/admin/register" className="inline-block ml-1 font-medium text-sage-700 hover:text-sage-900 underline underline-offset-4" >
            Créer un compte
          </Link>
        </p>
      </div>
    </div>
  )
}
